export function DateTimeFormatter(dateString) {
  const date_options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };
  const time_options = {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
    timeZoneName: "short",
    hour12: false
  };
  if (dateString != null) {
    let timestamp = new Date(Date.parse(dateString));
    let result = timestamp.toLocaleDateString("en-GB", date_options);
    result += " @" + timestamp.toLocaleTimeString([], time_options);
    return result;
  } else {
    return "--";
  }
}
